import React from "react";
import SeoArticlePage from "../../components/SeoArticlePage";

export default function DeclarationRevenusFonciers() {
  return (
    <SeoArticlePage
      seo={{
        title: "Déclaration des revenus fonciers : micro-foncier ou régime réel | 360immoinvest",
        description:
          "Micro-foncier ou régime réel ? Charges déductibles, formulaire 2044 et aide à la déclaration de vos revenus fonciers avec 360immoinvest.",
        path: "/declaration-revenus-fonciers",
        testid: "seo-fonciers-page",
      }}
      eyebrow="Guide du bailleur"
      h1="Déclarer ses revenus fonciers : micro-foncier ou régime réel"
      intro="Les loyers perçus pour une location vide sont imposés au titre des revenus fonciers. Deux régimes existent : le micro-foncier et le régime réel. 360immoinvest suit vos loyers et vos charges toute l'année pour préparer votre déclaration."
      sections={[
        {
          title: "Que sont les revenus fonciers ?",
          paragraphs: [
            "Les revenus fonciers correspondent aux loyers encaissés pour la location de logements non meublés (location vide). Ils s'ajoutent à vos autres revenus et sont soumis à l'impôt sur le revenu ainsi qu'aux prélèvements sociaux.",
            "La location meublée relève, elle, d'un autre régime (les bénéfices industriels et commerciaux, BIC), avec des règles différentes.",
          ],
        },
        {
          title: "Micro-foncier ou régime réel ?",
          paragraphs: [
            "Le micro-foncier s'applique automatiquement lorsque vos revenus fonciers bruts annuels ne dépassent pas 15 000 €. Vous bénéficiez alors d'un abattement forfaitaire de 30 %, censé couvrir vos charges : vous n'êtes imposé que sur 70 % des loyers.",
            "Le régime réel s'applique au-delà de 15 000 €, ou sur option. Il permet de déduire vos charges réelles (intérêts d'emprunt, travaux, taxe foncière, assurance, frais de gestion…). Il est souvent plus avantageux si vos charges dépassent 30 % de vos loyers.",
          ],
        },
        {
          title: "Les principales charges déductibles au réel",
          bullets: [
            "Les intérêts et frais d'emprunt",
            "Les dépenses de réparation, d'entretien et d'amélioration",
            "La taxe foncière",
            "Les primes d'assurance (dont la garantie loyers impayés)",
            "Les frais de gestion et honoraires",
            "Les provisions pour charges de copropriété non récupérables",
          ],
        },
        {
          title: "Quels formulaires remplir ?",
          paragraphs: [
            "En micro-foncier, vous reportez simplement le montant brut de vos loyers sur la déclaration de revenus (formulaire 2042) : l'abattement de 30 % est appliqué automatiquement.",
            "Au régime réel, vous détaillez vos loyers et vos charges sur le formulaire 2044 (ou 2044 spéciale selon les cas), puis vous reportez le résultat sur la 2042.",
          ],
        },
        {
          title: "L'aide à la déclaration avec 360immoinvest",
          paragraphs: [
            "L'application enregistre vos loyers encaissés et vos dépenses au fil de l'année, par bien. Au moment de déclarer, vous disposez d'une synthèse claire de vos revenus et de vos charges déductibles, prête à reporter sur les bons formulaires.",
            "Cette synthèse est fournie à titre d'aide et ne remplace pas un conseil fiscal personnalisé : en cas de doute, rapprochez-vous d'un professionnel.",
          ],
        },
      ]}
      faq={[
        { q: "Quel est le seuil du micro-foncier ?", a: "Le micro-foncier s'applique tant que vos revenus fonciers bruts annuels ne dépassent pas 15 000 €. Au-delà, le régime réel s'applique." },
        { q: "L'abattement du micro-foncier est-il de 30 % ?", a: "Oui. En micro-foncier, un abattement forfaitaire de 30 % est appliqué automatiquement : vous n'êtes imposé que sur 70 % des loyers." },
        { q: "Le régime réel est-il plus intéressant ?", a: "Il l'est généralement lorsque vos charges réelles (intérêts, travaux, taxe foncière…) dépassent 30 % de vos loyers, car vous les déduisez pour leur montant réel." },
        { q: "Quel formulaire pour le régime réel ?", a: "Vous détaillez vos revenus et charges sur le formulaire 2044, puis reportez le résultat sur votre déclaration 2042." },
      ]}
      related={[
        { to: "/quittance-de-loyer", label: "Quittance de loyer" },
        { to: "/revision-loyer-irl", label: "Révision de loyer (IRL)" },
        { to: "/tarifs", label: "Voir les tarifs" },
      ]}
    />
  );
}
